import { Builder } from '@builder.io/sdk';
import { LandingPageChecklist, LANDING_PAGE_CHECKLIST_COMPONENT_NAME } from './LandingPageChecklist';

const LandingPageChecklistConfig = {
  name: LANDING_PAGE_CHECKLIST_COMPONENT_NAME,
  friendlyName: 'Landing Page Checklist',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      friendlyName: 'Heading',
      helperText: 'Main heading displayed above the checklist',
      defaultValue: 'Ever found yourself looking for a different type of insurance?',
      required: false,
    },
    {
      name: 'subtitle',
      type: 'string',
      friendlyName: 'Subtitle',
      helperText: 'Supporting text displayed below the heading, above the checklist items',
      defaultValue: "One that's flexible and gives you stress-free driving when you're:",
      required: false,
    },
    {
      name: 'items',
      type: 'list',
      friendlyName: 'Checklist Items',
      helperText: 'List of checklist items displayed with checkmark icons',
      subFields: [
        {
          name: 'text',
          type: 'string',
          friendlyName: 'Item Text',
          helperText: 'The text content for this checklist item',
          required: true,
        },
      ],
      defaultValue: [
        { text: 'Needing to borrow a car or van for a few days or weeks' },
        { text: 'Test-driving, sorting cover for your new wheels or waiting for your old car to sell' },
        { text: 'Looking for a bit of time to shop around for regular insurance' },
        {
          text: 'Hitting the open road and wanting to share the drive without the hassle of adjusting existing cover',
        },
        { text: 'Faced with a last-minute change of plans or in an emergency' },
      ],
    },
  ],
};

Builder.registerComponent(LandingPageChecklist, LandingPageChecklistConfig);
